import { Link } from "gatsby";
import React from "react";
import { useTranslation } from "../../contexts/TranslationContext";

function FacebookIcon({ className = "" }: { className: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`w-6 h-6 ${className}`}>
      <path d="M279.14 288l14.22-92.66h-88.91V127.41c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S251.6 0 218.55 0C141.09 0 89.09 48.42 89.09 136.29v59.05H0v92.66h89.09V512h107.58V288z" />
    </svg>
  );
}

const p: any = {
  en: "Ensuring trusted cargo inspections worldwide. Precision, reliability, and peace of mind with every shipment.",
  fr: "Garantir des inspections de cargaison de confiance dans le monde entier. Précision, fiabilité et tranquillité d'esprit pour chaque expédition.",
};

interface FooterProps {
  onOpenNewsletterModal: () => void;
}

export default function Footer({ onOpenNewsletterModal }: FooterProps) {
  const { t, lang } = useTranslation();

  return (
    <div>
      <footer className="py-12 bg-gray-800 text-white">
        <div className="justify-around gap-y-8 grid sm:grid-cols-[auto,minmax(auto,400px)] lg:grid-cols-[auto_minmax(auto,250px)_auto_minmax(auto,400px)] mx-auto px-4 lg:px-12">
          <div>
            <h4 className="mb-6 font-semibold">Quick Links</h4>
            <ul>
              <li className="mb-2">
                <Link to={`/${lang}`} className="hover:underline">
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link to={`/${lang}/certificates`} className="hover:underline">
                  Certification
                </Link>
              </li>
              <li className="mb-2">
                <Link to={`/${lang}/about-us`} className="hover:underline">
                  About Us
                </Link>
              </li>
              <li className="mb-2">
                <Link to={`/${lang}/faq/faqs`} className="hover:underline">
                  FAQ
                </Link>
              </li>
              <li className="mb-2">
                <Link to={`/${lang}/contact/apply`} className="hover:underline">
                  Contact
                </Link>
              </li>
              <li className="mb-2">
                <Link to={`/quiz`} className="hover:underline">
                  Iftar Knowledge Challenge
                </Link>
              </li>
              <li className="mb-2">
                <Link to={`/academy`} className="hover:underline">
                  Academy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-6 font-semibold">Contact Information</h4>
            <p className="mb-2">Imm Selim, Building "SLIM", 2nd Floor, Rue de l'Euro, Tunis 1053</p>
            <p className="mb-2">Email: info@halalsciencecenter.com</p>
            <p>Phone: (+216) 70.022.614</p>
          </div>

          <div>
            <h4 className="mb-6 font-semibold">Follow Us</h4>
            <div className="flex space-x-4">
              <a target="_blank" href="https://www.facebook.com/profile.php?id=61576716068986">
                <img src="/social/fb.webp" alt="Facebook" className="w-6 h-6" />
              </a>
              {/* <a href="#">
                <img src="/social/ins.webp" alt="Instagram" className="w-6 h-6" />
              </a> */}
              <a target="_blank" href="https://www.linkedin.com/company/halal-science-and-certification-center/">
                <img src="/social/lin.webp" alt="LinkedIn" className="w-6 h-6" />
              </a>
            </div>
            <h4 className="mt-6 mb-4 font-semibold">Subscribe to newsletter</h4>
            <button
              type="button"
              onClick={onOpenNewsletterModal}
              className="w-full py-1 rounded-md bg-blue-600 hover:bg-blue-700 text-white transition-colors"
            >
              Subscribe
            </button>
          </div>

          {/* <div>
            <h4 className="mb-6 font-semibold">Newsletter Signup</h4>
            <form>
              <input type="email" placeholder="Your email" className="w-full mb-4 px-4 py-2 rounded-md text-gray-800" />
              <button className="w-full py-2 rounded-md bg-blue-600 text-white">Sign Up</button>
            </form>
          </div> */}
          <div className="mx-auto">
            <h4 className="mb-4 font-semibold text-xl text-center">Part of Halal Correct Certification - Group</h4>
            <div className="flex items-center gap-4 w-fit mx-auto mt-1 p-2 rounded bg-white">
              <img src="/logo.png" className="h-[125px] px-2" />
              <div className="self-stretch w-px bg-slate-500 shrink-0"></div>
              <a target="_blank" href="https://halalcorrect.com">
                <img src="/hcc-logo.png" className="h-[125px]" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <footer className="px-2 py-6 bg-blue-600">
        <div className="mx-auto text-white text-center container">
          <p>&copy; 2024 Halal Sciences and Certification Center (HSCC). All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
